import { ButtonGroup } from "../../../components/Form/ButtonGroup";

const typeButtonData = [
  {
    name: "상담접수",
    value: "CONSULTING",
  },
  {
    name: "진료접수",
    value: "TREATMENT",
  },
  {
    name: "시/수술접수",
    value: "SURGERY",
  },
];

type RegistrationTypeButtonProps = {
  value: any;
  onChange: (value: any) => void;
};

export const RegistrationTypeButton = ({
  value,
  onChange,
}: RegistrationTypeButtonProps) => {
  return (
    <ButtonGroup
      value={value}
      isToggle={false}
      onChange={onChange}
      buttonData={typeButtonData}
    />
  );
};
